import React from "react";
import {
  Row,
  Col,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { formattedDate, getBookingStatus } from "../../helpers/Helper";
import filterFactory, { selectFilter, textFilter, dateFilter } from 'react-bootstrap-table2-filter';
import { useNavigate } from "react-router-dom";
import TableNoDataIndication from "../common/TableNoDataIndication";

const { SearchBar } = Search;
const TransactionList = ({
  data,
  loading
}) => {
  const navigate = useNavigate();
  const afterSearch = (newResult) => {
    console.log(newResult);
  };

  const tblColumn = [
    {
      dataField: '',
      text: 'Sr.No.',
      formatter: (value, row, index) => {
        return (<>{index + 1}</>)
      }
    },
    {
      dataField: "xray_booking_id",
      text: "Booking Id",
      sort: true,
      formatter: (value, row) => {
        return (
          <span
            onClick={() => navigate(`/view-booking-detail/${row.booking_id}`)}
            style={{ cursor: 'pointer' }}
          >
            {row.xray_booking_id}
          </span>
        );
      }
    },
    {
      dataField: "user",
      text: "User",
      sort: true,
      formatter: (value, row) => {
        return (
          <span
            onClick={() => navigate(`/user-info/${row.user_details?._id}`)}
            style={{ cursor: 'pointer' }}
          >
            {row.user_details?.name || 'N/A'}
          </span>
        );
      }
    },
    {
      dataField: "center",
      text: "Assigned Center",
      sort: true,
      formatter: (value, row) => {
        return <span>{row.center_details?.name || 'N/A'}</span>;
      }
    },
    {
      dataField: "payment_for",
      text: "Payment For",
      sort: true,
      formatter: (value, row) => {
        return <span>{row.xray_type_details.name || 'N/A'}</span>;
      }
    },
    {
      dataField: "payment_mode",
      text: "Payment Mode",
      sort: true,
      // filter: textFilter()
    },

    {
      dataField: "transaction_date",
      text: "Transaction Date",
      sort: false,
      formatter: (value, row) => {
        return <span>{formattedDate(row.transaction_date)}</span>;
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      // filter: textFilter()
    },
  ];

  const defaultSorted = [
    {
      dataField: "_id",
      order: "desc",
    },
  ];
  const pzipcodeOptions = {
    sizePerPzipcode: 10,
    totalSize: data.length, // replace later with size(customers),
    custom: true,
  };
  return (
    <React.Fragment>
      <PaginationProvider
        pagination={paginationFactory(pzipcodeOptions)}
        keyField="id"
        columns={tblColumn}
        data={data}
      >
        {({ paginationProps, paginationTableProps, }) => (

          <ToolkitProvider keyField="_id" columns={tblColumn} data={data} search={{ afterSearch }}>
            {(toolkitProps) => (
              <React.Fragment>
                <Row className="mb-2" style={{ display: "none" }}>
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="status-relative"></div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xl="12">
                    <div className="text-right col-md-2 offset-md-10 mb-2">
                      <label className="pe-3">Search</label>
                      <SearchBar className="w-100" {...toolkitProps.searchProps} />
                    </div>
                    <div className="table-responsive">
                      <BootstrapTable
                        noDataIndication={<TableNoDataIndication loading={loading} />}
                        keyField={"id"}
                        responsive
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes={
                          "table table-striped align-middle table-nowrap"
                        }
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                      // filter={ filterFactory()}
                      />
                    </div>
                  </Col>
                </Row>
                {data.length > 0 && (
                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination mt-2 d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </React.Fragment>
  );
};

export default TransactionList;
